import {Button, Dialog, DialogTrigger, Link, OverlayArrow, Popover} from 'react-aria-components';
import "./Header.css";
import React, {useState} from "react";
import {LuUserCircle} from "react-icons/lu";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Logo from "../Logo/Logo";
import viteReact from "@vitejs/plugin-react";

function UserMenu() {
    const [isOpen, setIsOpen] = useState(false)
    const profileStr = localStorage.getItem("profile")
    const profile = JSON.parse(profileStr)
    const isLoggedIn = profile !== null
    let isAdmin = false
    if (isLoggedIn) {
        const email = profile.profile.email
        const adminEmails = ["john.veilstream.certn@gmail.com", "john@veilstream.com", "steve@veilstream.com"]
        for (const adminEmail of adminEmails) {
            if (email === adminEmail) {
                isAdmin = true
                break
            }
        }
    }

    return <DialogTrigger
        isOpen={isOpen}
        onOpenChange={(isOpen) => {
            setIsOpen(isOpen)
        }}
        aria-label="account menu"
    >
        <Button
            id={"user-menu-button"}
            onPress={() => {setIsOpen(!isOpen)}}
            style={{
                cursor: "pointer",
            }}
        >
             <LuUserCircle className="user-logo" />
        </Button>
        <Popover
            className="popover"
            style={{position:"absolute", right:10, top:"65px"}}
        >
            <OverlayArrow className="dropdown-arrow">
                <svg className="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="32" height="16" viewBox="0 0 32 16" fill="none">
                    <path d="M32 16.4525L16 0.452547L3.70842e-06 16.4525" stroke="#4A548B"/>
                </svg>
            </OverlayArrow>
            <Dialog className="dropdown-content" aria-label="account menu">
                {isAdmin ?<Link href="/admin">Internal Admin</Link> : null}
                <Link href={`/organization_users`}>My Organization</Link>
                <Link href="https://docs.veilstream.com">Documentation</Link>
                <Link href="/logout">Logout</Link>
            </Dialog>
        </Popover>
    </DialogTrigger>
}


function TopLeft() {
    return <div className="left">
        <Link href="/">
            <Logo/>
        </Link>
    </div>
}

function Header() {
    let profile = localStorage.getItem("profile")
    profile = JSON.parse(profile)
    const isLoggedIn = profile !== null

    if (!isLoggedIn) {
        return <div id="topNav">
            <TopLeft/>
            <div className="right">
                <ToastContainer theme="dark"/>
            </div>
        </div>
    }

    const links = [
        <Link href="/databases" key="dbs">Databases</Link>,
        <Link href="/users" key="users">Users</Link>,
        <Link href="/roles" key="roles">Roles</Link>
    ]

    const isDebug = import.meta.env.VITE_DEBUG === "true"
    const toastCloseMs = isDebug? 500 : 5000
    return <div id="topNav">
        <TopLeft/>
        <div className="right">
            {links}
            <UserMenu/>
            <ToastContainer theme="dark" autoClose={toastCloseMs}/>
        </div>
    </div>
}

export default Header;